export default function AcceptanceFacilitiesSection() {
  const facilities = [
    {
      name: "Westminster Main Post Office",
      address: "2750 W 86th Ave, Westminster, CO 80031",
      hours: "Mon–Fri 9:00 AM – 4:00 PM, Sat 9:00 AM – 12:00 PM",
      phone: "(303) 427-8381",
      notes: "Primary passport acceptance facility for Westminster residents. Photo services available on-site. Saturday hours available — call ahead to confirm passport clerk availability.",
      website: "https://tools.usps.com/find-location.htm",
    },
    {
      name: "Broomfield Post Office",
      address: "400 Nickel St, Broomfield, CO 80020",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(303) 469-0143",
      notes: "Convenient for northeast Westminster and Broomfield residents. Passport acceptance by appointment. Appointment recommended — walk-ins subject to clerk availability.",
      website: "https://tools.usps.com/find-location.htm",
    },
    {
      name: "Arvada Post Office",
      address: "7500 W 53rd Ave, Arvada, CO 80002",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(303) 424-2600",
      notes: "Serves south Westminster and west Arvada residents. Call ahead for current wait times and photo service availability.",
      website: "https://tools.usps.com/find-location.htm",
    },
    {
      name: "Thornton Post Office",
      address: "12191 Grant St, Thornton, CO 80241",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(303) 452-8381",
      notes: "Alternative for east Westminster and Thornton area residents. Photo services available on-site. Appointment recommended during busy spring travel season.",
      website: "https://tools.usps.com/find-location.htm",
    },
  ];

  return (
    <section id="acceptance-facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Passport Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where to Submit a New Passport in Westminster
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            First-time applicants and minors must visit an acceptance clerk in person to submit their application. Westminster-area residents can use these facilities — though most travelers using Fast Passport Center ship documents directly to us after their clerk visit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {facilities.map((f, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
                  <i className="ri-map-pin-2-line text-[#1A365D] text-base"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{f.name}</h3>
                  <p className="text-gray-500 text-xs mt-0.5">{f.address}</p>
                </div>
              </div>
              <div className="space-y-1.5 text-xs text-gray-500 ml-12">
                <p><i className="ri-time-line text-[#F6C344] mr-1"></i>{f.hours}</p>
                <p><i className="ri-phone-line text-[#F6C344] mr-1"></i>{f.phone}</p>
                <p>
                  <i className="ri-global-line text-[#F6C344] mr-1"></i>
                  <a
                    href={f.website}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2"
                  >
                    Visit website
                  </a>
                </p>
              </div>
              <div className="mt-3 ml-12 bg-white rounded-md p-3 border border-gray-200">
                <p className="text-gray-500 text-xs leading-relaxed">{f.notes}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-6 flex flex-col md:flex-row items-center gap-5 text-center md:text-left">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-lightbulb-line text-[#1A365D] text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="text-white font-bold text-base mb-1">How This Works With Fast Passport Center</p>
            <p className="text-white/60 text-sm leading-relaxed">
              Visit the clerk with your sealed envelope, then ship it overnight to Fast Passport Center for expedited processing. We handle the rest — no need to wait for standard mail timelines.
            </p>
          </div>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0"
          >
            Start Now <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}